export default {
  ['title']: 'Login',
  ['submit-text']: 'Login',
  ['reset-text']: 'Reset Password',
  ['email']: 'E-mail',
  ['password']: 'Password',
  ['placeholder-input']: 'Please Input',
  ['message-submit-success']: 'Register Success'
}
